<style>
.grid{
  display: grid;
  grid-template-columns: 33% 33% 34%;
  margin-top: 20px;
}
.a{
  grid-column: 1;
  text-align: center;
  border: 1px rgba(0,0,0,0) solid;
  padding: 5px 0;
}
.b{
  grid-column: 2;
  text-align: center;
  border: 1px rgba(0,0,0,0) solid;
  padding: 5px 0;
}
.c{
  grid-column: 3;
  text-align: center;
  border: 1px rgba(0,0,0,0) solid;
  padding: 5px 0;
}

</style>

<div class="grid">
  <div class="a {selM == 0 ? 'sel' : ''} {grayed > 0 ? '' : 'hide'}" on:click="{ () => uSelM(0) }">Jan</div>
  <div class="b {selM == 1 ? 'sel' : ''} {grayed > 1 ? '' : 'hide'}" on:click="{ () => uSelM(1) }">Feb</div>
  <div class="c {selM == 2 ? 'sel' : ''} {grayed > 2 ? '' : 'hide'}" on:click="{ () => uSelM(2) }">Mar</div>
</div>

<div class="grid">
  <div class="a {selM == 3 ? 'sel' : ''} {grayed > 3 ? '' : 'hide'}" on:click="{ () => uSelM(3) }">Apr</div>
  <div class="b {selM == 4 ? 'sel' : ''} {grayed > 4 ? '' : 'hide'}" on:click="{ () => uSelM(4) }">May</div>
  <div class="c {selM == 5 ? 'sel' : ''} {grayed > 5 ? '' : 'hide'}" on:click="{ () => uSelM(5) }">Jun</div>
</div>

<div class="grid">
  <div class="a {selM == 6 ? 'sel' : ''} {grayed > 6 ? '' : 'hide'}" on:click="{ () => uSelM(6) }">Jul</div>
  <div class="b {selM == 7 ? 'sel' : ''} {grayed > 7 ? '' : 'hide'}" on:click="{ () => uSelM(7) }">Aug</div>
  <div class="c {selM == 8 ? 'sel' : ''} {grayed > 8 ? '' : 'hide'}" on:click="{ () => uSelM(8) }">Sep</div>
</div>

<div class="grid">
  <div class="a {selM == 9 ? 'sel' : ''} {grayed > 9 ? '' : 'hide'}" on:click="{ () => uSelM(9) }">Oct</div>
  <div class="b {selM == 10 ? 'sel' : ''} {grayed > 10 ? '' : 'hide'}" on:click="{ () => uSelM(10) }">Nov</div>
  <div class="c {selM == 11 ? 'sel' : ''} {grayed > 11 ? '' : 'hide'}" on:click="{ () => uSelM(11) }">Dec</div>
</div>




<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let month = "MM";
export let year = "YYYY";

// lower this number to gray out months
let grayed = 12;

$:{
  if (year) {
    parseDate();
  }
}

function parseDate() {
  let curYear = new Date().getFullYear() - 18;
  if ( parseInt(year) == curYear ) {
    grayed = new Date().getMonth() + 1;
    // console.log("grayed:", grayed);
  } else {
    grayed = 12;
  }
  
  selM = month - 1;
}

let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// selected month
let selM = -1;


function uSelM(i) {
  selM = i;
  done();
}

function done() {
  if (selM != -1) month = selM + 1;
  // console.log("month:", month);
  dispatch("changed");
}

</script>